import styled from "styled-components";

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 0;
  background-color: ${({ theme, disabled }) => disabled ? theme.colors.gray200 : theme.colors.blue400};
  color: ${({ theme, disabled }) => disabled ? theme.colors.gray400 : theme.colors.white};
  height: 56px;
  width: 100%;
  border-radius: 8px;

  @media (min-width: 724px) { 
    width: ${({ wFull }) => wFull? "100%": "384px"}; 
  }

    ${({ styleType, theme }) => { 
    if (styleType === "link") 
      return `
        width: auto; 
        height: 0px;
        background-color: transparent;
        padding: 0px;
        margin: 0px;
        margin-left: 4px; 
        color: ${theme.colors.blue400};
        @media (min-width: 724px) { 
          width: auto; 
        }
      `
  }}

`